


































































































































































































































































































































































/* tslint:disable:max-classes-per-file */
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Getter, Mutation} from 'vuex-class';
import ExplorerService from '@/services/explorer.service';
import {
  DataSet,
  DataSetMetadata,
  ExplorerConfiguration,
  ExplorerView,
  IDataTableHeader,
} from '@/types';
import DataSetService from '@/services/dataset.service';
import Dialog from '@/components/Dialog.vue';
import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';
import GenericButton from '@/components/GenericButton.vue';
import CreateViewConfigurationDialog from '@/components/dataexplorer/CreateViewConfigurationDialog.vue';
import EditViewConfigurationDialog from '@/components/dataexplorer/EditViewConfigurationDialog.vue';
import Table from '@/components/Table.vue';
import moment from 'moment';
import DatetimePicker from '@/components/DatetimePicker.vue';
import EventBus from '../../services/eventbus.service';
import { GlobalTokenManager } from '../../classes/axios.cancel.token';
import axios from 'axios';

@Component({
  components: {
    DatetimePicker,
    Table,
    EditViewConfigurationDialog,
    CreateViewConfigurationDialog, GenericButton, ConfirmButton, CancelButton, Dialog},
})
export default class DataExplorer extends Vue {
  @Getter private hasPermission: any;
  @Getter private activeOrganisation: any;
  @Getter private activeOrganisationId: any;
  @Getter private lastView!: ExplorerView;
  @Getter private login: any;
  @Mutation private setLastView: any;
  @Mutation private clearLastView: any;

  private selectedHeaders: Record<string, boolean> = {};

  private perPage: number = 100;
  private itemsPerPage: number = 100;
  private page: number = 1;

  private defaultOptions = {
    page: 1,
    itemsPerPage: this.itemsPerPage,
  };
  private options: any = { ...this.defaultOptions };
  private readonly defaultTotalItems: number = 0;
  private totalItems: number = this.defaultTotalItems;

  private views: ExplorerView[] = [];
  private presetDurations: string[] = ['1', '7', '12', '24'];
  private queryData: QueryData = {
    take: this.itemsPerPage,
    skip: 0,
    sort: 'time',
    desc: false,
    filters: {},
  };

  private tableData: {
    headers: IDataTableHeader[];
    rows: any[];
    total: number;
    filters: any;
  } = {
    headers: [],
    rows: [],
    total: 0,
    filters: {},
  };

  private view: ExplorerView | null = null;
  private metadata: DataSetMetadata | null = null;
  private viewToDelete: ExplorerView | null = null;

  private showCreateConfigurationDialog: boolean = false;
  private showDeleteViewDialog: boolean = false;
  private showEditConfigurationDialog: boolean = false;
  private viewWasEdited: boolean = false;
  private enableApply: boolean = false;

  private exportRequested: boolean = false;

  private tableMsg: any = {
    type: '',
    msg: '',
  };
  private dialogError: string = '';
  private mainLoading: boolean = false;
  private editable: boolean = false;
  private addColumnMenu: {[key: string]: boolean} = {};

  private get viewList(): ExplorerView[] {
    return this.views.sort(byName);
  }

  private get datasetName(): string {
    return this.view ? this.view.dataset_name : '';
  }

  private get disableTimeFilters(): boolean {
    if (this.view) {
      if (this.view.configuration.filters.time === 'absolute') {
        return !(this.view.configuration.filters.to || this.view.configuration.filters.from);
      } else if (this.view.configuration.filters.time === 'relative') {
        return !(this.view.configuration.filters.period || this.view.configuration.filters.duration);
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  private async mounted() {
    this.views = await ExplorerService.getAllExplorerViewConfigurations();
    if (this.views.length) {
      this.tableMsg = { type: 'info', msg: 'Loading results...' };

      if (this.lastView && this.lastView.id && this.lastView.organisation_id === this.activeOrganisationId) {
        await this.changeView(this.lastView);
      } else {
        await this.changeView(this.views[0]);
      }
    } else {
      await this.openCreationDialog();
    }
  }

  @Watch('activeOrganisationId')
  private async onOrgChange(value: number, newValue: number) {
    if (value !== newValue) {
      this.clearLastView();
    }
  }

  private get previousMonthDate() {
    return moment().subtract(1, 'months');
  }

  private async onOptionsChanged(opts: any) {
    this.options = opts;
  }

  /**
   * Change view
   */
  private async changeView(view: ExplorerView): Promise<void> {
    this.queryData.filters = {};
    this.view = this.viewWasEdited || !view.name ? await ExplorerService.getExplorerViewConfiguration(Number(view.id)) : view;
    this.setLastView(this.view);

    const [metadata, refreshed] = await Promise.all([
      DataSetService.getDatasetMetadata(this.view.dataset_uuid),
      this.refreshData(),
    ]);

    if (refreshed) {
      this.metadata = metadata;
      await this.viewEdited(this.view);
    }

    this.editable = true;
  }

  private async viewEdited(view: ExplorerView) {
    this.tableData.headers = view.configuration.layout.headers.map((h: any) => ({
      text: h.text,
      value: h.value,
      queryKey: h.value,
      filterable: true,
      sortable: false,
      hideSort: h.value !== 'time',
      ...(!h.isCustomField && h.value !== 'time' ? { allowedFilterValues: this.getFilterValues(h.value) } : h.value === 'time' ? { allowedFilterValues: [] } : {}),
    }));
    this.viewWasEdited = true;
  }

  private getFilterValues(fieldName: string) {
    switch (fieldName) {
      case 'interface':
        return sorted(Object.keys(this.metadata!.interfaces));
      case 'deviceType':
        return sorted(Object.keys(this.metadata!.deviceTypes));
      case 'eventType':
        return sorted(Object.values(this.metadata!.deviceTypes).flatMap((dt: any) => Object.keys(dt)));
      default:
        return this.metadata!.tags[fieldName] ? sorted(this.metadata!.tags[fieldName]!) : [];
    }
  }
  /**
   * Data
   */
  private async refreshData(): Promise<boolean> {
    this.mainLoading = true;

    if (this.view) {
      const { since, before } = this.getTimeRange();

      try {
        // ignore any refreshes that might already be in flight
        GlobalTokenManager.cancel();
        const data = await DataSetService.getDatasetData(this.view.dataset_uuid, { // get one more than 100, to know there are more results
          timeOrder: this.queryData.desc ? 'desc' : 'asc',
          limit: 101,
          offset: this.queryData.skip,
          since,
          before,
          tags: this.queryData.filters,
          includeStock: this.view.configuration.filters.includeStock || false,
          includeTestBench: this.view.configuration.filters.includeTestBench || false,
        });
        this.totalItems = Math.max(this.totalItems, this.queryData.skip + data.results.length);

        if (data.results.length > 100) {
          data.results.slice(0, -1);
        }

        this.tableData.rows = data.results;
        this.tableMsg = { msg: '', type: 'info' };
        return true;
      } catch (e: any) {
        if (!axios.isCancel(e)) {
          this.tableMsg = { type: 'error', msg: e.message };
          this.tableData.rows = [];
        }
      } finally {
        if (!this.tableData.rows.length && this.tableMsg.type !== 'error') {
          this.tableMsg = { msg: 'No results to display' };
        }
        this.mainLoading = false;
      }
    }
    return false;
  }

  private async updateQueryData(queryData: QueryData) {
    if (this.queryData.skip === queryData.skip) {
      // something else has changed, reset pagination
      this.page = 1;
      this.totalItems = 0;
    }

    Vue.set(this, 'queryData', queryData);

    try {
      this.mainLoading = true;
      if (!(this.view && this.views.length)) {
        this.tableMsg = {type: 'warning', msg: 'No views available'};
      }
      this.tableMsg = {type: 'info', msg: 'Loading results...'};
      await this.refreshData();
    } catch (e: any) {
      this.tableMsg = { type: 'error', msg: 'Error loading results' };
    } finally {
      this.mainLoading = false;
    }
  }

  private getTimeRange(): { since: string | Date | undefined | number, before: string | Date | undefined | number }  {
    this.view!.configuration.filters.period = this.view!.configuration.filters.period || 'days';
    const since = this.view && this.view.configuration.filters.time === 'relative'
        ? moment().subtract(Number(this.view.configuration.filters.duration), String(this.view.configuration.filters.period) as moment.unitOfTime.DurationConstructor).format('YYYY-MM-DD HH:mm')
        : this.view!.configuration.filters.from;

    const before = this.view && this.view.configuration.filters.time === 'relative'
      ? moment(new Date()).format('YYYY-MM-DD HH:mm')
      : this.view!.configuration.filters.to;

    return { since, before };
  }

  /**
   * Views
   */
  private async viewCreated(view: any) {
    this.views.push(view);
    await this.changeView(view);
  }

  private async deleteView(view: ExplorerView) {
    if (view) {
      this.showDeleteViewDialog = false;

      await ExplorerService.deleteExplorerViewConfiguration(Number(view.id));

      this.views = this.views.filter((v: ExplorerView) => v.id !== view.id);

      if (this.view && this.view.id === view.id) {
        if (this.views.length > 0) {
          this.changeView(this.views[0]);
        } else {
          this.clearLastView();
          this.view = null;
          this.tableData = {
            headers: [],
            rows: [],
            total: 0,
            filters: {},
          };
        }
      }
    }

    this.editable = false;
  }

  private async saveView() {
    this.mainLoading = true;

    if (this.view) {
      this.view.configuration.filters.columns = this.queryData.filters;
      const updatedView = await ExplorerService.updateExplorerViewConfiguration(this.view);

      this.views.splice(this.views.findIndex((v: ExplorerView) => v.id === updatedView.id), 1, updatedView);
    }

    this.mainLoading = false;
    this.viewWasEdited = false;
  }

  private async applyTimeFilter(clear: boolean) {
    if (clear && this.view) {
      this.view.configuration.filters = {};
    }
    this.totalItems = 0;
    if (this.page !== 1) {
      this.page = 1; // this generates a refresh itself
    } else {
      await this.refreshData();
    }
  }

  /**
   * Filters
   */
  private updateDatetime(datetime: string, source: string) {
    this.viewWasEdited = true;
    Vue.set(this.view!.configuration.filters, source, datetime);
  }

  private changeDuration(duration: number) {
    if (duration <= 0) {
      this.view!.configuration.filters.duration = 0;
    }
  }

  /**
   * Table
   */
  private removeHeader(header: string) {
    const indexToRemove = this.view!.configuration.layout.headers.findIndex((h: IDataTableHeader) => h.value === header);
    this.view!.configuration.layout.removedHeaders.push(this.view!.configuration.layout.headers.splice(indexToRemove, 1)[0]);
    this.viewEdited(this.view!);
  }

  private async revertColumns() {
    this.view!.configuration.layout.headers = [...this.view!.configuration.layout.headers, ...this.view!.configuration.layout.removedHeaders];
    this.view!.configuration.layout.removedHeaders = [];
    if (this.view) {
      await this.refreshData();
      this.viewEdited(this.view);
    }
    this.viewWasEdited = true;
  }

  private addHeader(colToAdd: IDataTableHeader, clickedHeader: string) {
    if (!!this.view!.configuration.layout.removedHeaders.find((c) => c.value === colToAdd.value)) {
      const indexOfSource = this.view!.configuration.layout.headers.findIndex(
          (h) => h.value === clickedHeader,
      );
      this.view!.configuration.layout.headers.splice(indexOfSource + 1, 0, colToAdd);
      this.view!.configuration.layout.removedHeaders = this.view!.configuration.layout.removedHeaders.filter(
          (c) => c.value !== colToAdd.value,
      );
      this.selectedHeaders[colToAdd.value] = false;

      this.viewEdited(this.view!);
    }
  }

  /**
   * Dialogs
   */
  private async openCreationDialog() {
    this.tableData = {
      headers: [],
      rows: [],
      total: 0,
      filters: {},
    };
    this.view = null;
    this.showCreateConfigurationDialog = true;
    this.tableMsg = { msg: '', type: 'info' };
  }

  private async exportCsv() {
    if (this.view) {
      try {
        this.exportRequested = true;
        const options = {
          timeOrder: this.queryData.desc ? 'desc' : 'asc',
          ...this.getTimeRange(),
          ...this.queryData.filters,
          columns: this.view.configuration.layout.headers.map((h) => h.value),
          aliases: this.view.configuration.layout.headers.map((h) => h.text),
          includeStock: this.view.configuration.filters.includeStock || false,
          includeTestBench: this.view.configuration.filters.includeTestBench || false,
        };
        const { job_id } = await ExplorerService.export(Number(this.view.id), this.view.dataset_uuid, options);
        EventBus.$emit('jobCreated', job_id);
      } finally {
        this.exportRequested = false;
      }

    }
  }
}

const byName = (a: ExplorerView, b: ExplorerView) => {
  if (a.name.toLowerCase() < b.name.toLowerCase()) {
    return -1;
  } else if (a.name.toLowerCase() > b.name.toLowerCase()) {
    return 1;
  } else {
    return 0;
  }
};

const sorted = (arr: any[]): any[] =>
    arr.sort((a: any, b: any): number => {
        return a.localeCompare(b, undefined, {numeric: true, sensitivity: 'base'});
    });

interface QueryData {
    take: number;
    skip: number;
    sort: string;
    desc: boolean;
    filters: { [key: string]: any };
}
